import React from "react";
import FormBuilder from "../form_components/FormBuilder";
import Input from "../form_components/Input";
import { useAppDispatch } from "../../hooks";
import { fetchProjects } from "../../features/Project/ProjectSlice";

export default function AddNote() {
    const now = new Date();
    const maxDateTime = now.toISOString().slice(0, 16); 
    return (
        <>  
            <FormBuilder title='Add Note' post={'/projects/addNote'}>
                <Input width='full' label="Text" type='text' placeholder='This is a note' extraClasses='border block rounded px-2' required={true} value='' onChange={(name, value) => { }} name='comment' />
                <Input width='full' label="Timestamp" type='datetime-local' max={maxDateTime} placeholder='' extraClasses='border block rounded px-2' required={true} value='' onChange={(name, value) => { }} name='timestamp' />
            </FormBuilder>
        </>
    );
}